export default {
  OS: 'web',
  Version: 0,
  select: (obj)=>{
    return obj.web || {};
  }
}